// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"156":"f8f10e08","488":"ac842e8f","668":"3625d6b8","990":"ef220140"}[chunkId] + ".chunk.css";
};